import React, {useState, useEffect} from 'react';
import {Link, Route} from 'react-router-dom';
import axios from 'axios';
import EditMuseumDetail from './edit-museum-detail-page'

function MuseumEditList (){
    const [museums, setMuseums] = useState([]);

    useEffect(()=>{
        getMuseumList()
    }, []);

    const image_in_list = `${process.env.PUBLIC_URL}/project_exhibition.jpg`


    function getMuseumList(){
        axios.get('/api/museum_list/all')
        .then(museumListFromMongo=>{
            setMuseums(museumListFromMongo.data)
        })
        .catch(error=>{
            console.log(error)
        })
    };


    return(
        <div className='museumList'>
            <ul className='admin_museum_list'>
              {museums.map((museum)=>
              <li key={museum._id}><Link to={`/admin/private/museum-list/detail/${museum._id}`}>
                   <div className='museum_list_img_wrapper'>
                   <img src={museum.image==''? image_in_list:museum.image}/>
                   <h3>{museum.name}</h3>
                   <p>{museum.image_copyright}</p>
                   </div>
                  </Link>
                  </li>
              )}
             </ul>
         
        </div>
    )
}

export default MuseumEditList;